import React from "react";
import Decimal from "decimal.js-light";
import { styled } from "@mui/material/styles";

import { Labeled, useRecordContext } from "react-admin";

import { useTotalInclShipping } from "./TotalInclShipping";
import { useReconciledPayment } from "./ReconciledPayment";
import { useGetDiscountValue } from "../components/Voucher/useGetDiscount";
import { AmountWithTaxColorField } from "./AmountWithTaxField";
import { getTaxCalculation } from "../components/Taxation/withTaxCalculation";
import { useGetCreditPayment } from "../components/Credit/hooks";

const BalanceSpan = styled("span")(({ color }) => ({
  color:
    color === "green"
      ? "#4caf50"
      : color === "red"
      ? "red"
      : color === "amber"
      ? "orange"
      : "black",
}));

export const useGetOutstandingPaymentInclShipping = ({ record = {} }) => {
  const { payments = [], tax } = record;
  const { totalDiscount: discountValue } = useGetDiscountValue(record);
  const totalInclShipping = useTotalInclShipping(record);
  const totalReconciledPaidAmount = useReconciledPayment(payments);
  const totalCreditPayment = useGetCreditPayment(payments);

  if (tax) {
    const { outstandingPayment } = getTaxCalculation(record);
    return new Decimal(outstandingPayment);
  } else {
    const balanceDecimal = new Decimal(totalInclShipping)
      .minus(totalReconciledPaidAmount)
      .minus(discountValue)
      .minus(totalCreditPayment);
    return balanceDecimal;
  }
};

const OutstandingPaymentInclShippingField = ({ record = {}, label }) => {
  const balanceDecimal = useGetOutstandingPaymentInclShipping({ record });
  const balance = balanceDecimal.toFixed(2);

  const color = balanceDecimal.isZero()
    ? "green"
    : balanceDecimal.isPositive()
    ? "red"
    : "amber";

  if (label) {
    return (
      <Labeled label={label}>
        <BalanceSpan color={color}>{balance}</BalanceSpan>
      </Labeled>
    );
  }
  return <BalanceSpan color={color}>{balance}</BalanceSpan>;
};

export const OutstandingPaymentField = (props) => {
  const { record } = props;
  if (!!record.tax) {
    return <AmountWithTaxColorField {...props} />;
  }
  return <OutstandingPaymentInclShippingField {...props} />;
};

const withRecordContext = (WrapComp) => (props) => {
  const record = useRecordContext();
  return <WrapComp {...props} record={record} />;
};

export default withRecordContext(OutstandingPaymentField);
